import { render, staticRenderFns } from "./AgregarProductoFormComponent.vue?vue&type=template&id=630b2f3c&"
import script from "./AgregarProductoFormComponent.vue?vue&type=script&lang=js&"
export * from "./AgregarProductoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports